import { EnrollmentStatus } from '@trialcard/enums/EnrollmentStatus';
import { IFieldBase } from './ruleTypes';
import { IHeader } from './componentTypes';

export interface ISearchFields extends IFieldBase {
    getHeaderConfig(): IHeader[];
    // validate(): boolean;
}

export enum PatientSearchUniqueIdenitfierType {
    MedicalMemberId = 1,
    PharmacyMemberId = 2,
    AccountNumber = 3,
    ThirdPartyId = 4
}

export enum SearchEnrollmentStatus {
    'Approved' = EnrollmentStatus.Approved,
    'Rejected' = EnrollmentStatus.Rejected,
    'Review Required' = EnrollmentStatus.Review_Required,
    'Review Processing' = EnrollmentStatus.Review_Processing,
    'Intake Processing' = EnrollmentStatus.Intake_Processing,
    'Unenrolled' = EnrollmentStatus.Disenrolled,
    'Enrolled' = EnrollmentStatus.Enrolled,
    'Canceled' = EnrollmentStatus.Canceled,
    'Open' = EnrollmentStatus.Open,
    'Unknown' = EnrollmentStatus.Unknown,
    'Expired' = EnrollmentStatus.EXP
}
